<script>
  /* global Global */
  import Live from './Live.svelte';
  import SeparatorVertical from '../SeparatorVertical.svelte';
  import Common from '../../js/common.js';
  import { onDestroy } from 'svelte';

  let value = [];

  let timeoutId;

  (async function refresh () {
    if (!Global.live.timeout || new Date(Global.date.countdown).getTime() > new Date().getTime() || Global.live.standings.length > 0) return;

    // eslint-disable-next-line no-undef
    const response = await fetch(`${Common.BACKEND_URL}/live/get`);

    if (response.ok) {
      const data = await response.json();

      value = data;
    }

    // eslint-disable-next-line no-magic-numbers
    timeoutId = setTimeout(refresh, Global.live.timeout);
  })();

  onDestroy(() => { clearTimeout(timeoutId); });

  let liveBoxElement;

  const width = 395;

  async function scrollLeft () {
    liveBoxElement.scroll({ left: liveBoxElement.scrollLeft - width, behavior: 'smooth' });
  }

  async function scrollRight () {
    liveBoxElement.scroll({ left: liveBoxElement.scrollLeft + width, behavior: 'smooth' });
  }
</script>

{#if value.length > 1}
  <div class='live-box-prepend' on:click={scrollLeft}>
    <span class='material-icons'> chevron_left </span>
  </div>
{/if}

<div class='live-box' bind:this={liveBoxElement}>
  {#each value as item, idx}
    <Live value={item}/>

    {#if idx !== value.length - 1}
      <SeparatorVertical/>
    {/if}
  {/each}
</div>

{#if value.length > 1}
  <div class='live-box-append' on:click={scrollRight}>
    <span class='material-icons'> chevron_right </span>
  </div>
{/if}

<style>
  .live-box {
    display: flex;
    gap: 30px;

    padding: 20px 60px;

    overflow-x: scroll;

    scrollbar-width: none;
  }

  .live-box::-webkit-scrollbar {
    display: none;
  }

  .live-box-prepend {
    position: absolute;
    left: 0px;

    display: flex;
    justify-content: center;
    align-items: center;

    width: 20px;
    height: 100%;

    z-index: 1;

    color: var(--grey-5);

    cursor: pointer;
    user-select: none;

    transition: background-color 0.25s ease-in-out;
  }

  .live-box-prepend:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }

  .live-box-prepend:active {
    background-color: rgba(0, 0, 0, 0.2);
  }

  .live-box-append {
    position: absolute;
    right: 0px;

    display: flex;
    justify-content: center;
    align-items: center;

    width: 20px;
    height: 100%;

    z-index: 1;

    color: var(--grey-5);

    cursor: pointer;
    user-select: none;

    transition: background-color 0.25s ease-in-out;
  }

  .live-box-append:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }

  .live-box-append:active {
    background-color: rgba(0, 0, 0, 0.2);
  }

  :global(body.dark) .live-box-prepend {
    color: var(--grey-6);
  }

  :global(body.dark) .live-box-prepend:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }

  :global(body.dark) .live-box-prepend:active {
    background-color: rgba(255, 255, 255, 0.2);
  }

  :global(body.dark) .live-box-append {
    color: var(--grey-6);
  }

  :global(body.dark) .live-box-append:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }

  :global(body.dark) .live-box-append:active {
    background-color: rgba(255, 255, 255, 0.2);
  }

  @media only screen and (max-width: 900px) {
    .live-box {
      padding: 20px 40px;
    }
  }

  @media only screen and (max-width: 415px) {
    .live-box {
      padding: 20px calc((100% - 335px) / 2);
    }
  }
</style>
